(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[972],{

/***/ 9469:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-is-guitar-string-tension.en",
      function () {
        return __webpack_require__(4830);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6499:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/negative_fret.20d9b088.jpg","height":862,"width":2028,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAaEAACAgMAAAAAAAAAAAAAAAAAAQIDBDFB/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/EABURAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIRAxEAPwCd5Em6N8QADTj/2Q==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 7786:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/standard_vs_baritone.02f68110.jpg","height":1490,"width":1488,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAACAgIDAAAAAAAAAAAAAAAAAQIRAwQhMUH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABYRAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEQMRAD8AneFQelKrbeHiNe30AAmmo5L/2Q==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 7179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ strings; }
/* harmony export */ });
const strings = {
    "en": {
        Title: "String Tension Calculator",
        Description: "Find the right string gauge for your guitar or bass to achieve the perfect tension.",
        Scale: "Scale",
        Note: "Note",
        Gauge: "Gauge",
        Tension: "Tension",
        Frequency: "Frequency",
        Guitar: "Guitar",
        Bass: "Bass",
        CopyLink: "Copy Link",
        Copied: "Copied!",
        SingleScale: "Single Scale",
        Multiscale: "Multiscale",
        SelectYourScale: "Select Your Scale",
        AddString: "Add String",
        "HelpBox.StringTension": "String Tension",
        "HelpBox.ColorOfTension": 'The color of the tension value in the table shows how light (or heavy)\n    the string is, with "yellow" being lighter and "red" being heavier.',
        "HelpBox.TypicallyForGuitars": "Typically for guitars:",
        "HelpBox.TypicallyForBasses": "And for basses",
        "HelpBox.LightTension": "light tension",
        "HelpBox.RegularTension": "regular tension",
        "HelpBox.HeavyTension": "heavy tension",
        "HelpBox.ValuesMayVary": "Although these values may vary depending on the instrument technical\n    characteristics.",
        "HelpBox.Lighter": "LIGHTER",
        "HelpBox.Heavier": "HEAVIER"
    },
    "ua": {
        Title: "Калькулятор натягу струн",
        Description: "Знайдіть правильний калібр струн для своєї гітари або бас-гітари для досягнення ідеального натягу.",
        Scale: "Мензура",
        Note: "Нота",
        Gauge: "Калібр",
        Tension: "Натяг",
        Frequency: "Частота",
        Guitar: "Гітара",
        Bass: "Бас",
        CopyLink: "Скопіювати посилання",
        Copied: "Скопійовано!",
        SingleScale: "Звичайна мензура",
        Multiscale: "Мультимензура",
        SelectYourScale: "Виберіть мензуру",
        AddString: "Додати струну",
        "HelpBox.StringTension": "Натяг струн",
        "HelpBox.ColorOfTension": "Колір цифри натягу струни в таблиці показує наскільки сильно натягнута струна. Жовтий колір означає, що струна натягнута слабо, червоний — сильно.",
        "HelpBox.TypicallyForGuitars": "Звичайні значення для гітар:",
        "HelpBox.TypicallyForBasses": "Tа для басів",
        "HelpBox.LightTension": "легкий натяг",
        "HelpBox.RegularTension": "звичайний натяг",
        "HelpBox.HeavyTension": "сильний натяг",
        "HelpBox.ValuesMayVary": "Дані значення можуть помітно відрізнятися залежно від інструменту та його технічних характеристик",
        "HelpBox.Lighter": "ЛЕГШЕ",
        "HelpBox.Heavier": "СИЛЬНІШЕ"
    },
    "ru": {
        Title: "Калькулятор натяжения струн",
        Description: "Найдите правильный калибр струн для своей гитары или бас-гитары, чтобы достичь идеального натяжения.",
        Scale: "Мензура",
        Note: "Нота",
        Gauge: "Калибр",
        Tension: "Натяжение",
        Frequency: "Частота",
        Guitar: "Гитара",
        Bass: "Бас",
        CopyLink: "Скопировать ссылку",
        Copied: "Скопировано!",
        SingleScale: "Обычная мензура",
        Multiscale: "Мультимензура",
        SelectYourScale: "Выберите мензуру",
        AddString: "Добавить струну",
        "HelpBox.StringTension": "Натяжение струн",
        "HelpBox.ColorOfTension": "Цвет цифры натяжение струны в таблице показывает как сильно струна натянута. Желтый цвет означает что струна натянута слабо, а красный что сильно",
        "HelpBox.TypicallyForGuitars": "Обычные значения для гитар:",
        "HelpBox.TypicallyForBasses": "Для басов",
        "HelpBox.LightTension": "легкое натяжение",
        "HelpBox.RegularTension": "обычное натяжение",
        "HelpBox.HeavyTension": "сильное натяжение",
        "HelpBox.ValuesMayVary": "Данные значение могут заметно оличатся в зависимости от инструмента и его технических характеристик",
        "HelpBox.Lighter": "ЛЕГЧЕ",
        "HelpBox.Heavier": "СИЛЬНЕЕ"
    }
};


/***/ }),

/***/ 5204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Sample; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1834);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ui_Shimmer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9554);



/* harmony default export */ __webpack_exports__["Z"] = (next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(201), __webpack_require__.e(185), __webpack_require__.e(798), __webpack_require__.e(631)]).then(__webpack_require__.bind(__webpack_require__, 9631)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9631)
            ]
    },
    loading: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_Shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {}),
    ssr: false
}));
const Sample = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(201), __webpack_require__.e(185), __webpack_require__.e(798), __webpack_require__.e(631), __webpack_require__.e(742)]).then(__webpack_require__.bind(__webpack_require__, 6742)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6742)
            ]
    },
    loading: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_Shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {}),
    ssr: false
});


/***/ }),

/***/ 9554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Shimmer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(959);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6851);



const styles = {
    spinner: {
        width: "40px",
        height: "40px",
        border: "5px solid rgba(0, 0, 0, 0.1)",
        borderTopColor: _styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.button */ .DM.button,
        borderRadius: "50%",
        animation: "spin 1s linear infinite"
    },
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100px",
        padding: "20px"
    }
};
const Shimmer = ()=>{
    const spinnerStyle = {
        width: "40px",
        height: "40px",
        border: "5px solid rgba(0, 0, 0, 0.1)",
        borderTopColor: _styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.button */ .DM.button,
        borderRadius: "50%",
        animation: "spin 1s linear infinite"
    };
    const keyframes = "\n        @keyframes spin {\n          0% {\n            transform: rotate(0deg);\n          }\n          100% {\n            transform: rotate(360deg);\n          }\n        }\n      ";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: styles.container,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: spinnerStyle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: keyframes
            })
        ]
    });
};


/***/ }),

/***/ 1604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ XLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3701);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6851);



const styles = {
    link: {
        color: _styles__WEBPACK_IMPORTED_MODULE_2__/* .COLORS.primaryHue */ .DM.primaryHue
    }
};
function XLink(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        style: styles.link,
        href: props.href,
        target: props.target,
        children: props.children
    });
}


/***/ }),

/***/ 6851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ COLORS; },
/* harmony export */   "LI": function() { return /* binding */ button; },
/* harmony export */   "nZ": function() { return /* binding */ selector; },
/* harmony export */   "nb": function() { return /* binding */ FONT; }
/* harmony export */ });
const FONT = "Fira Sans Extra Condensed,sans-serif";
const COLORS = {
    lightBackground: "#2a2a33",
    buttonBackground: "#383845",
    arrow: "#fff",
    lightGrayText: "#6a6a7c",
    button: "#663df3",
    border: "#292b33",
    primaryHue: "hsl(204, 100%, 50%)"
};
const button = {
    borderRadius: "29px",
    background: COLORS.button,
    boxShadow: "inset 3px 3px rgb(114, 74, 244), 0 0 2px rgb(0, 0, 0)",
    border: "0",
    minHeight: "39px",
    fontFamily: FONT,
    lineHeight: "35px",
    fontSize: "16px",
    color: "white",
    cursor: "pointer"
};
const selector = {
    appearance: "none",
    backgroundColor: COLORS.lightBackground,
    color: "white",
    padding: "10px",
    border: "0",
    minHeight: "40px",
    borderRadius: "3px",
    backgroundImage: "url(/dropdown.png)",
    backgroundPosition: "right",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    fontFamily: FONT,
    fontSize: "15px",
    width: "100%"
};


/***/ }),

/***/ 6408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(959);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3886);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ts_pattern__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7749);
/* harmony import */ var _src_calc_i18nStrings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7179);





const config = {
    project: {},
    chat: {},
    footer: {
        component: undefined
    },
    sidebar: {
        toggleButton: true
    },
    nextThemes: {
        forcedTheme: "dark"
    },
    // primaryHue: { dark: 4, light: 4 },
    darkMode: true,
    editLink: {
        component: undefined
    },
    feedback: {
        content: undefined
    },
    i18n: [
        {
            locale: "en",
            text: "English"
        },
        {
            locale: "ua",
            text: "Ukrainian (українська)"
        },
        {
            locale: "ru",
            text: "Russian (русский)"
        }
    ],
    head: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=G-7RT4L8C5YF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\nwindow.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}\ngtag('js', new Date());\n\ngtag('config', 'G-7RT4L8C5YF');\n"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                async: true,
                src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1374017065120638",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "https://fonts.googleapis.com/css?family=Fira+Sans+Extra+Condensed",
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico",
                type: "image/x-icon"
            })
        ]
    }),
    logo: ()=>{
        const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
        const locale = router.locale;
        const title = (0,ts_pattern__WEBPACK_IMPORTED_MODULE_3__/* .match */ .EQ)(locale).with("en", ()=>"String Tension Calculator").with("ru", ()=>"Калькулятор Натяжения Струн").with("ua", ()=>"Калькулятор Натягу Струн").with(ts_pattern__WEBPACK_IMPORTED_MODULE_3__.P.any, ()=>"String Tension Calculator").exhaustive();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/logo_header.png",
                    style: {
                        width: "35px",
                        height: "42px"
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    style: {
                        marginLeft: "20px",
                        fontFamily: "Fira Sans Extra Condensed,sans-serif",
                        fontSize: "24px",
                        fontWeight: "bold",
                        lineHeight: "28px"
                    },
                    children: title
                })
            ]
        });
    },
    themeSwitch: {
        component: null
    },
    search: {
        component: undefined
    },
    // search: { placeholder: "Search..." },
    navigation: {
        prev: false,
        next: false
    },
    // banner: { text: "MEOW" }, // support ukraine?
    docsRepositoryBase: "https://github.com/aaronabramov/string-calc",
    useNextSeoProps: ()=>{
        const { route , locale  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
        // deduplication of all `q=sontheusnathoesu` urls to avoid
        // over-indexing
        const canonical = (0,ts_pattern__WEBPACK_IMPORTED_MODULE_3__/* .match */ .EQ)(route).with("/index.en", ()=>"https://www.stringtensioncalculator.com").with("/index.ru", ()=>"https://www.stringtensioncalculator.com/ru/").with("/index.ua", ()=>"https://www.stringtensioncalculator.com/ua/").with(ts_pattern__WEBPACK_IMPORTED_MODULE_3__.P.any, ()=>undefined).exhaustive();
        const ogImage = (0,ts_pattern__WEBPACK_IMPORTED_MODULE_3__/* .match */ .EQ)(locale).with("ru", ()=>"/og-ru.jpeg").with("ua", ()=>"/og-ua.jpeg").with("en", ()=>"/og-en.jpeg").with(ts_pattern__WEBPACK_IMPORTED_MODULE_3__.P.any, ()=>"/og-en.jpeg").exhaustive();
        const localizedStrings = (0,ts_pattern__WEBPACK_IMPORTED_MODULE_3__/* .match */ .EQ)(locale).with("ua", ()=>_src_calc_i18nStrings__WEBPACK_IMPORTED_MODULE_4__/* .strings.ua */ .j.ua).with("ru", ()=>_src_calc_i18nStrings__WEBPACK_IMPORTED_MODULE_4__/* .strings.ru */ .j.ru).with("en", ()=>_src_calc_i18nStrings__WEBPACK_IMPORTED_MODULE_4__/* .strings.en */ .j.en).with(ts_pattern__WEBPACK_IMPORTED_MODULE_3__.P.any, ()=>_src_calc_i18nStrings__WEBPACK_IMPORTED_MODULE_4__/* .strings.en */ .j.en).exhaustive();
        return {
            canonical,
            titleTemplate: "%s",
            description: localizedStrings.Description,
            openGraph: {
                images: [
                    {
                        url: ogImage,
                        width: 2424,
                        height: 1269,
                        alt: localizedStrings.Title,
                        type: "image/jpeg"
                    }
                ]
            }
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (config);


/***/ }),

/***/ 4830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1527);
/* harmony import */ var nextra_setup_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7664);
/* harmony import */ var nextra_theme_docs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9227);
/* harmony import */ var _vercel_path0_theme_config_tsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6408);
/* harmony import */ var nextra_theme_docs_style_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1324);
/* harmony import */ var nextra_theme_docs_style_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(nextra_theme_docs_style_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var nextra_mdx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6736);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6484);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _vercel_path0_public_standard_vs_baritone_jpg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7786);
/* harmony import */ var _vercel_path0_public_negative_fret_jpg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6499);
/* harmony import */ var _src_calc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5204);
/* harmony import */ var _src_calc_ui_XLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1604);





const __nextraPageOptions = {
    MDXContent,
    pageOpts: {
        "filePath": "pages/what-is-guitar-string-tension.en.mdx",
        "route": "/what-is-guitar-string-tension",
        "headings": [
            {
                "depth": 1,
                "value": "What is guitar string tension?",
                "id": "what-is-guitar-string-tension"
            },
            {
                "depth": 2,
                "value": "What Affects String Tension?",
                "id": "what-affects-string-tension"
            },
            {
                "depth": 3,
                "value": "1. String tuning (Pitch)",
                "id": "1-string-tuning-pitch"
            },
            {
                "depth": 3,
                "value": "2. String thickness (Gauge)",
                "id": "2-string-thickness-gauge"
            },
            {
                "depth": 3,
                "value": "3. String length (Scale)",
                "id": "3-string-length-scale"
            },
            {
                "depth": 3,
                "value": "4. String weight (Unit Weight)",
                "id": "4-string-weight-unit-weight"
            },
            {
                "depth": 4,
                "value": "Common string materials",
                "id": "common-string-materials"
            },
            {
                "depth": 4,
                "value": "Different string manufacturers",
                "id": "different-string-manufacturers"
            }
        ],
        "timestamp": 1684445074000,
        "pageMap": [
            {
                "kind": "Meta",
                "locale": "en",
                "data": {
                    "index": {
                        "title": "String Tension Calculator",
                        "theme": {
                            "breadcrumb": false,
                            "sidebar": true
                        }
                    },
                    "what-is-guitar-string-tension": {
                        "title": "What is guitar string tension?",
                        "theme": {
                            "breadcrumb": false,
                            "sidebar": true
                        }
                    },
                    "contact": {
                        "title": "Contact ↗",
                        "type": "page",
                        "href": "https://x.com/boujeepossum",
                        "newWindow": true
                    }
                }
            },
            {
                "kind": "MdxPage",
                "name": "index",
                "route": "/",
                "locale": "en",
                "frontMatter": {
                    "title": "String Tension Calculator"
                }
            },
            {
                "kind": "MdxPage",
                "name": "what-is-guitar-string-tension",
                "route": "/what-is-guitar-string-tension",
                "locale": "en"
            }
        ],
        "flexsearch": {
            "codeblocks": true
        },
        "title": "What is guitar string tension?"
    },
    pageNextRoute: "/what-is-guitar-string-tension.en",
    nextraLayout: nextra_theme_docs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP,
    themeConfig: _vercel_path0_theme_config_tsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
};
/*@jsxRuntime automatic @jsxImportSource react*/ 





function _createMdxContent(props) {
    const _components = Object.assign({
        h1: "h1",
        p: "p",
        code: "code",
        h2: "h2",
        h3: "h3",
        h4: "h4",
        ol: "ol",
        li: "li"
    }, (0,nextra_mdx__WEBPACK_IMPORTED_MODULE_10__/* .useMDXComponents */ .ah)(), props.components);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h1, {
                children: "What is guitar string tension?"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Imagine that a guitar string is like a rubber band. When it's stretched tight, it has more tension or \"stretchiness.\" Guitar strings need to be tight enough to make a nice sound when struck with a pick. However, if they're too tight, they can be difficult to play, and if they're too loose, they may produce a weird buzzing noise. Striking the right balance of tightness helps the guitar sound good and be easy to play."
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "We measure string tension in pounds (",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "lbs"
                    }),
                    "). The higher the number, the tighter the string is."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    'For a guitar, "average" or "regular" tension is typically around ',
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "18 lbs"
                    }),
                    "."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "If the tension is lower, around ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "13 lbs"
                    }),
                    ", you may notice the string hitting the frets of your neck, producing a distinct buzzing sound."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "On the other hand, a tighter tension, around ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "22 lbs"
                    }),
                    ", will feel harder to play because you will need to apply more force to produce sound from the string."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                id: "what-affects-string-tension",
                children: "What Affects String Tension?"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                id: "1-string-tuning-pitch",
                children: "1. String tuning (Pitch)"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "The higher you tune a string, the tighter it will become. For example, a guitar may be tuned to standard ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc_ui_XLink__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        href: "/?s=N4IgxgliBcoQLjEBzEAaEBnTEAmTcAPAG3S0xgG1KQBRAFnQCYBWAOhbSYF00aAhAMzN2nAJy8aAcWFdRaAIwtJIACKzWHLoJUBBJiK1MJfOgblbBANm7cAvnaA%3D",
                        target: "_blank",
                        children: "EBGDAE"
                    }),
                    " tuning (",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "Standard E"
                    }),
                    "). The lower (thicker) ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "E2"
                    }),
                    " string is a ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "0.048"
                    }),
                    " gauge string that has an average tension."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc__WEBPACK_IMPORTED_MODULE_8__/* .Sample */ .d, {
                name: "SingleStringE"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "If you tune that last string one tone down to ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "Drop D"
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc_ui_XLink__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        href: "/?s=N4IgxgliBcoQLjEBzEAaEBnTEAmTcAPAG3S0xgG1KQBRAFnQCYBWAOhbSYF00aAhAMzN2nAJy8aAcWFdRaAIwtJIACKzWHLoJUBBJiK1MJfNQblbBANm7cAvnaA%3D",
                        target: "_blank",
                        children: "EBGDAD"
                    }),
                    ", you will notice that the string becomes noticeably looser."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc__WEBPACK_IMPORTED_MODULE_8__/* .Sample */ .d, {
                name: "SingleStringDropD"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                id: "2-string-thickness-gauge",
                children: "2. String thickness (Gauge)"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "A thicker rubber band is harder to stretch than a thinner one. Similarly, thicker guitar strings require more tension than thinner ones."
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "If you've tuned your guitar to ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "Drop D"
                    }),
                    " and noticed buzzing on the last string, try replacing it with a thicker string. This will provide a similar feel (almost) to your old string tuned to ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "E"
                    }),
                    "."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "You can see that swapping it with a ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "0.054"
                    }),
                    " gauge string brings the tension back to the original ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "18 lbs"
                    }),
                    "-ish"
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc__WEBPACK_IMPORTED_MODULE_8__/* .Sample */ .d, {
                name: "SingleStringDropDThicker"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                id: "3-string-length-scale",
                children: "3. String length (Scale)"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "You might have heard of baritone guitars. Baritone guitars are similar to normal guitars, but their neck or scale is slightly longer, which means the vibrating part of the string will also be longer."
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "The scale is measured in inches, and the most common scale is ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "25.5 inches"
                    }),
                    "."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                    alt: "Standard 25.5 inch scale vs Baritone 27.5 inch",
                    placeholder: "blur",
                    src: _vercel_path0_public_standard_vs_baritone_jpg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
                })
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "The longer the string, the more it needs to stretch to produce the note at the same pitch."
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc__WEBPACK_IMPORTED_MODULE_8__/* .Sample */ .d, {
                name: "TwoStringsSamePitchAndGaugeDifferentScale"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Think of it like this: when you play a guitar, the higher up the fret you play, the higher the pitch of the note. The lowest note you can play on a string is an open note, where you don't hold any frets. Because baritone guitars have a longer scale, you can think of it as having a fret ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "-1"
                    }),
                    " which gives you a lower note while the string gauge and tension remain the same."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                    alt: "Longer scale is like having an extra negative fret",
                    placeholder: "blur",
                    src: _vercel_path0_public_negative_fret_jpg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
                })
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "However, if you tune the baritone string so that an open string produces an ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "E"
                    }),
                    " instead of a ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.code, {
                        children: "D#"
                    }),
                    ", the tension will increase."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Longer scale guitars are often used to achieve lower tunings without having to use thicker strings. You can see that the same exact string will have very similar tension on a larger scale guitar, even though it's tuned the whole tone down."
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc__WEBPACK_IMPORTED_MODULE_8__/* .Sample */ .d, {
                name: "TwoStringsSameGaugeDifferentScale"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                id: "4-string-weight-unit-weight",
                children: "4. String weight (Unit Weight)"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Not all strings are created equal. Some strings are heavier than others."
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "For example, one inch of a nickel string with a certain gauge will be slightly heavier than one inch of a steel string with the same gauge."
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "The heavier the string, the tighter it needs to be tuned to achieve the same pitch."
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h4, {
                id: "common-string-materials",
                children: "Common string materials"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.ol, {
                children: [
                    "\n",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                        children: "Steel: Steel strings are commonly used for electric guitars and steel-string acoustic guitars due to their bright and clear tone. Typically, they are made from a steel core wrapped with different metal alloys, such as nickel, stainless steel, or nickel-plated steel. Among these types, pure steel strings are usually the lightest."
                    }),
                    "\n",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                        children: "Nickel: Nickel strings are popular for electric guitars due to their warm and smooth tone. They are slightly heavier than pure steel strings but lighter than some other materials. Nickel-wound strings have a steel core wrapped with pure nickel or nickel-plated steel."
                    }),
                    "\n",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                        children: "Bronze: Bronze strings are mainly used for acoustic guitars due to their bright and crisp tone. There are two popular types of bronze strings: 80/20 bronze (80% copper, 20% zinc) and phosphor bronze (a blend of copper with a small amount of phosphorous). Bronze strings are usually heavier than steel or nickel strings due to the density of copper."
                    }),
                    "\n",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.li, {
                        children: "Nylon: Nylon strings are commonly used for classical guitars due to their warm and mellow tone. They are typically lighter than steel, nickel, or bronze strings. There are two types of nylon strings: treble strings made from clear or rectified nylon and bass strings made from nylon wrapped with silver-plated copper or other materials."
                    }),
                    "\n"
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h4, {
                id: "different-string-manufacturers",
                children: "Different string manufacturers"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Although a string may be made of the same material, different brands of strings can have different weights. For instance, ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc_ui_XLink__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        href: "/?s=N4IgxgliBcoQLjEBzEAaEBnTEAmSBrARnS0xgG0KQBRAFnQCYBWAOmbUYF01qAhAMxM2HIgAYe1AOJDOItEWaSQAEVkt2nAOzKAgo2GaBdZTQNzNdCVwC%2BNoA%3D%3D%3D",
                        target: "_blank",
                        children: "Kalium strings"
                    }),
                    " are generally heavier than ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc_ui_XLink__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        href: "/?s=N4IgxgliBcoQLjEBzEAaEBnTEAmTcAPAG3S0xgG1KQBRAFnQCYBWAOhbSYF00aAhAMzN2nAJy8aAcWFdRaAIwtJIACKzWHLoJUBBJiK1MJfOgblbBAdm7cAvnaA%3D",
                        target: "_blank",
                        children: "D'Addario strings"
                    }),
                    ", and using the exact same gauge will result in slightly different tension."
                ]
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc__WEBPACK_IMPORTED_MODULE_8__/* .Sample */ .d, {
                name: "SingleStringDaddario"
            }),
            "\n",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_calc__WEBPACK_IMPORTED_MODULE_8__/* .Sample */ .d, {
                name: "SingleStringKalium"
            })
        ]
    });
}
function MDXContent() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { wrapper: MDXLayout  } = Object.assign({}, (0,nextra_mdx__WEBPACK_IMPORTED_MODULE_10__/* .useMDXComponents */ .ah)(), props.components);
    return MDXLayout ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, {
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, {
            ...props
        })
    }) : _createMdxContent(props);
}
if (false) {}
if (false) {}
/* harmony default export */ __webpack_exports__["default"] = ((0,nextra_setup_page__WEBPACK_IMPORTED_MODULE_1__/* .setupNextraPage */ .j)(__nextraPageOptions));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,722,888,179], function() { return __webpack_exec__(9469); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);